import * as C from '../../constants';
import SkiVisitGroupService from '../../../../services/ski/visitgroup-service';

export default {
  /**
   * @param commit
   */
  clearState({ commit }) {
    commit(C.SKI_VISITGROUP_CLEAR_STATE);
  },

  /**
   * @param commit
   * @returns {Promise<any | never>}
   */
  loadXmlChannels({ commit }) {
    commit(C.SKI_VISITGROUP_CHANNEL_LOAD_PENDING);
    return SkiVisitGroupService.getXmlChannels()
      .then(res => {
        commit(C.SKI_VISITGROUP_CHANNEL_LOAD_SUCCESS,
          res.data.sort((a, b) => (a.webservice > b.webservice ? 1 : -1)), );
      })
      .catch(err => {
        console.log(err);
        commit(C.SKI_VISITGROUP_CHANNEL_LOAD_FAILURE, err.response.data);
      });
  },

  /**
   * @param commit
   * @param state
   * @param payload
   */
  setXmlChannel({ commit, state, dispatch }, payload) {
    const xmlChannel = state.xmlChannels.items.find(
      item => item.id === payload,
    );
    commit(C.SKI_VISITGROUP_CHANNEL_CHANGE, xmlChannel);
    dispatch('getAddonsByXmlChannelId');
  },

  /**
   * @param commit
   * @param state
   */
  getAddonsByXmlChannelId({ commit, state }) {
    commit(C.SKI_VISITGROUP_CHANNEL_ADDONS_LIST_PENDING);
    return SkiVisitGroupService.getXmlChannelAddons(state.xmlChannels.xmlChannel.id)
      .then(res => {
        if (res.status === 200) {
          commit(C.SKI_VISITGROUP_CHANNEL_ADDONS_LIST_SUCCESS, res.data);
        } else {
          commit(C.SKI_VISITGROUP_CHANNEL_ADDONS_LIST_SUCCESS, []);
        }
      })
      .catch(err => {
        commit(C.SKI_VISITGROUP_CHANNEL_ADDONS_LIST_FAILURE, err.response.data);
      });
  },

  /**
   * @param commit
   * @param state
   * @param addon
   */
  updateAddon({ commit, state }, addon) {
    commit(C.SKI_VISITGROUP_CHANNEL_ADDONS_ALIGNED_EXTRA_UPDATE_PENDING, addon.id);
    return SkiVisitGroupService.updateAddon(addon)
      .then(() => {
        const addonIndex = state.addons.items.findIndex(item => item.id === addon.id);
        commit(C.SKI_VISITGROUP_CHANNEL_ADDONS_ALIGNED_EXTRA_UPDATE_SUCCESS,
          { index: addonIndex, id: addon.id, alignedExtraId: addon.alignedExtraId, isActive: addon.isActive });
      })
      .catch(err => {
        commit(C.SKI_VISITGROUP_CHANNEL_ADDONS_ALIGNED_EXTRA_UPDATE_FAILURE,
          { id: addon.id, error: err.response.data });
      });
  },

  /**
   * @param commit
   */
  showAddonAccommodationModal({ commit }, addon) {
    commit(C.SKI_VISITGROUP_CHANNEL_ADDONS_ACCOMMODATION_MODAL_SHOW, addon);
  },

  /**
   * @param commit
   */
  closeAddonAccommodationModal({ commit }) {
    commit(C.SKI_VISITGROUP_CHANNEL_ADDONS_ACCOMMODATION_MODAL_CLOSE);
  },

  /**
   * @param commit
   * @param payload
   */
  searchAddons({ commit }, payload) {
    commit(C.SKI_VISITGROUP_CHANNEL_ADDONS_SEARCH, payload);
  },
};




// WEBPACK FOOTER //
// ./src/store/modules/ski/visitgroup/actions.js